import React, { useCallback, useEffect, useMemo } from 'react';
import styles from './index.module.scss';
import AppCtrl from "../../../../control/AppCtrl";
import Config from '../../../../utils/Config';
import LANGUAGE_TYPE from "../../../../utils/Language";
import Table from '../../../_component/Table';

import moment from 'moment';

function PlayRecordsPage(props)
{    
    const text = Config.text.playRecordsPage;
    const SCORE_TYPE = {
        None: -1,
        Trial: 0,
        Formal: 1,
        GuoZhao: 2,
        TrialGuoZhao: 3
    }

    //===========================================================================
    useEffect(() => {
        //PreLoad();
        componentDidMount();
        return componentWillUnmount;
    }, []);
    // useEffect(() => {
    //     if (props.records) onQueryUserPlayRecords(props.records);
    // }, [props.records]);
    //===========================================================================

    function componentDidMount()
    {
        window.addEventListener('resize', onResize);
        onResize();

        // const offset = new Date().getTimezoneOffset();
        // console.log(`offset:${offset}`);
        // var curTime = new Date();
        // const year = curTime.getFullYear();
        // const month = curTime.getMonth();
        // const date = curTime.getDate();
        // const hour = offset / -60;
        // curTime = new Date(year, month, date, hour, 0, 0);
        // const uiETime = document.getElementById('ePlayRecordsTime');
        // if (uiETime) uiETime.valueAsDate = curTime;
        // const uiSTime = document.getElementById('sPlayRecordsTime');
        // if (uiSTime) uiSTime.valueAsDate = new Date(curTime.getTime() - 6*24*60*60*1000);
    }

    // function componentDidUpdate()
    // {

    // }

    function componentWillUnmount()
    {
        window.removeEventListener('resize', onResize);
    }

    function onResize()
    {
        const deviceWidth = window.innerWidth;
        const deviceHeight = window.innerHeight;

        const uiPlayRecordsPage = document.getElementById('playRecordsPage');
        if (uiPlayRecordsPage) {
            uiPlayRecordsPage.style.height = `${deviceHeight}px`;
            uiPlayRecordsPage.style.overflowY = "auto";
        }
    }

    // function onQueryUserPlayRecords(records)
    // {
    //     const language = AppCtrl.getLanguage();
    //     const actionList = records;
    //     const uiTbodyPlayRecords = document.getElementById('tbodyPlayRecords');
    //     if (uiTbodyPlayRecords) {
    //         let content = "";
    //         for (let i = 0 ; i < actionList.length ; i++) {
    //             const createTime = new Date(actionList[i].CreateTime);
    //             const year = createTime.getFullYear();
    //             const month = createTime.getMonth()+1 < 10 ? `0${createTime.getMonth()+1}` : createTime.getMonth()+1;
    //             const date = createTime.getDate() < 10 ? `0${createTime.getDate()}` : createTime.getDate();
    //             const hours = createTime.getHours() < 10 ? `0${createTime.getHours()}` : createTime.getHours();
    //             const minutes = createTime.getMinutes() < 10 ? `0${createTime.getMinutes()}` : createTime.getMinutes();
    //             const seconds = createTime.getSeconds() < 10 ? `0${createTime.getSeconds()}` : createTime.getSeconds();
    //             const objNote = JSON.parse(actionList[i].Note);
    //             const scoreType = objNote.hasOwnProperty('ScoreType') ? parseInt(objNote.ScoreType) : 0;
    //             const scores = objNote.TotalOutScore - objNote.TotalInScore;
    //             content += '<tr>';
    //             content +=  `<td>${i+1}</td>`;
    //             content +=  `<td>${year}/${month}/${date} ${hours}:${minutes}:${seconds}</td>`;
    //             content +=  `<td>${actionList[i].Machine}</td>`;
    //             switch (scoreType) {
    //                 case SCORE_TYPE.Trial:
    //                     if (language == LANGUAGE_TYPE.zh_TW) content += `<td>試玩: ${scores}</td>`;
    //                     else content += `<td>Trial:${scores}</td>`;
    //                     break;
    //                 case SCORE_TYPE.Formal:
    //                     if (language == LANGUAGE_TYPE.zh_TW) content += `<td>正式: ${scores}</td>`;
    //                     else content += `<td>Formal:${scores}</td>`;
    //                     break;
    //                 case SCORE_TYPE.GuoZhao:
    //                     if (language == LANGUAGE_TYPE.zh_TW) content += `<td>過招(正式): ${scores}</td>`;
    //                     else content += `<td>Guo Zhao(Formal):${scores}</td>`;
    //                     break;
    //                 case SCORE_TYPE.TrialGuoZhao:
    //                     if (language == LANGUAGE_TYPE.zh_TW) content += `<td>過招(試玩): ${scores}</td>`;
    //                     else content += `<td>Guo Zhao(Trial):${scores}</td>`;
    //                     break;
    //                 default:
    //                     if (language == LANGUAGE_TYPE.zh_TW) content += `<td>分數: ${scores}</td>`;
    //                     else content += `<td>Scores:${scores}</td>`;
    //                     break;
    //             }
    //             content += '</tr>';
    //         }

    //         uiTbodyPlayRecords.innerHTML = content;
    //     }
    // }

    const columns = useMemo(() => [
        { key: 'index', title: 'NO.', width: '5%' },
        { key: 'time', title: `${text.timeplayrecord}`, width: '35%' },
        { key: 'machine', title: `${text.machine}`},
        { key: 'score', title: `${text.scoreplayrecord}`}
    ], [text]);
    

    const data = useCallback((records) => {
        const language = AppCtrl.getLanguage();
        return records.map((record, index) => {
            const objNote = JSON.parse(record.Note);
            const scores = objNote.TotalOutScore - objNote.TotalInScore;

            const time = moment(record.CreateTime).format("YYYY/MM/DD HH:mm:ss");
            
            let scoreText;
            switch (parseInt(objNote.ScoreType)) {
                case SCORE_TYPE.Trial:
                    scoreText = language === LANGUAGE_TYPE.zh_TW ? `試玩: ${scores}` : `Trial:${scores}`;
                    break;
                case SCORE_TYPE.Formal:
                    scoreText = language === LANGUAGE_TYPE.zh_TW ? `正式: ${scores}` : `Formal:${scores}`;
                    break;
                case SCORE_TYPE.GuoZhao:
                    scoreText = language === LANGUAGE_TYPE.zh_TW ? `過招(正式): ${scores}` : `Guo Zhao(Formal):${scores}`;
                    break;
                case SCORE_TYPE.TrialGuoZhao:
                    scoreText = language === LANGUAGE_TYPE.zh_TW ? `過招(試玩): ${scores}` : `Guo Zhao(Trial):${scores}`;
                    break;
                default:
                    scoreText = language === LANGUAGE_TYPE.zh_TW ? `分數: ${scores}` : `Scores:${scores}`;
                    break;
            }
            
            return {
                index: index + 1,
                time,
                machine: record.Machine, // 假設每條記錄中都有機器名稱
                score: scoreText,
            }
        })
    }, []);
    

    return (                
        <div id="playRecordsPage" className={styles.playRecordsPage}>
            {/* <table style={{width:"100%", borderCollapse:"separate", borderSpacing:"0 2px", cellpadding:"10", border:"1"}}>
                <thead>
                    <tr style={{color:"white", backgroundColor:"#FFC107"}}>
                        <th style={{width:"5%", textAlign:"center", fontSize:"16px"}}>NO.</th>
                        <th style={{width:"35%", textAlign:"center", fontSize:"16px"}}>{`${text.timeplayrecord}`}</th>
                        <th style={{width:"30%", textAlign:"center", fontSize:"16px"}}>{`${text.machine}`}</th>
                        <th style={{width:"30%", textAlign:"center", fontSize:"16px"}}>{`${text.scoreplayrecord}`}</th>
                    </tr>
                </thead>
                <tbody id="tbodyPlayRecords">
                </tbody>
            </table> */}
            { props.records && props.records.length > 0 && <Table columns={columns} data={data(props.records)} /> }
        </div>
    );
}

export default PlayRecordsPage;